import {  defineMessages } from 'react-intl'

const messages = defineMessages({
    the_invitation_has_been_sent_to_the_email: {
        id: 'messages.the_invitation_has_been_sent_to_the_email',
        defaultMessage: 'Connection request successfully sent to the email'
    },
    invalid_email: {
        id: 'invalid_email',
        defaultMessage: 'Invalid Email'
    },
    this_email_is_not_exist: {
        id: 'messages.this_email_is_not_exist',
        defaultMessage: 'User not found - please check if the client has registered to the {name} mobile App.'
    },
    this_email_is_not_exist_web: {
        id: 'messages.this_email_is_not_exist_web',
        defaultMessage: 'User not found - please check if the user has registered to the {name} web App.'
    },
    this_email_is_already_connected_to_your_organization: {
        id: 'messages.this_email_is_already_connected_to_your_organization',
        defaultMessage: 'This email is already connected to your organization.'
    },
    this_email_is_already_invited_from_your_organization: {
        id: 'messages.this_email_is_already_invited_from_your_organization',
        defaultMessage: 'This email is already invited from your organization.'
    },
    this_email_is_already_connected_to_another_organization: {
        id: 'messages.this_email_is_already_connected_to_another_organization',
        defaultMessage: 'This email is already connected to another organization.'
    },
    this_email_is_not_client: {
      id: 'messages.this_email_is_not_client',
      defaultMessage: 'This email is not Client.'
    },
    only_letters_are_allowed: {
        id: 'messages.only_letters_are_allowed',
        defaultMessage: 'Only letters are allowed'
    },
    create_client_help_text: {
        id: 'invitation.create_client_help_text',
        defaultMessage: 'This action will create a new client profile in your pending profile list. When you create a client, automated connection request will be sent to the user with entered email - your client needs to confirm the connection request.',
    },
    install_mob_app_first: {
      id: 'invitation.install_mob_app_first',
      defaultMessage: 'The client must first install the {name} mobile app and create an account before you can send a connection request.',
    },
    check_spam: {
        id: 'invitation.check_spam',
        defaultMessage: 'The invitations to the client are sent via email. Please make sure your client checks the spam/junk section.'
    },
    check_spam2: {
        id: 'invitation.check_spam2',
        defaultMessage: 'You can also send the link directly after copying it from the "Connection Link".'
    },
    create_client_spam_text: {
        id: 'invitation.create_client_spam_text',
        defaultMessage: 'In case your client does not see the email, please double check spam/junk mail.'
    },
    create_client_help_text_bold: {
        id: 'invitation.create_client_help_text_bold',
        defaultMessage: 'By creating a client, you increase the number of clients on your subscription plan. If you archive or remove a client from the pending or active list, you decrease the number of clients on your subscription plan.'
    },
    create_client_help_text_bold_2: {
      id: 'invitation.create_client_help_text_bold_2',
      defaultMessage: 'The first 30 days after registration on the MFW platform are free.\n' +
        'After that, the subscription starts at €7.49 per month for 0–4 clients.\n' +
        'After the 5th client, the subscription increases for each additional client.'
    },
    create_client_help_text_bold_3: {
      id: 'invitation.create_client_help_text_bold_3',
      defaultMessage: 'Subscription details can be viewed'
    },
    create_client_help_text_bold_3_here: {
      id: 'invitation.create_client_help_text_bold_3_here',
      defaultMessage: ' HERE'
    },
    invitation_disabled: {
        id: 'invitation.invitation_disabled',
        defaultMessage: 'If you cannot send the invitation, contact your organization admin.'
    },
    sending_connection_request: {
        id: 'messages.sending_connection_request',
        defaultMessage: 'Sending connection request'
    },
    admin: {
        id: 'role.admin',
        defaultMessage: 'Admin'
    },
    assistanttrainer: {
        id: 'role.assistanttrainer',
        defaultMessage: 'Assistant Trainer'
    },
    client: {
        id: 'role.client',
        defaultMessage: 'Client'
    },
    trainer: {
        id: 'role.trainer',
        defaultMessage: 'Trainer'
    },
    add_client: {
        id: 'button.add_client',
        defaultMessage: ' + Add Client'
    },
    manage_subscriptions: {
        id: 'invitation.manage_subscriptions',
        defaultMessage: 'Manage subscriptions'
    },
    create_member: {
        id: 'Create member',
        defaultMessage: 'Create Member'
    },
    are_you_sure_you_want_to_remove: {
        id: 'are_you_sure_you_want_to_remove',
        defaultMessage: 'Are you sure you want to remove {name} from the pending list?'
    },
    free_clients_limit: {
        id: 'invitation.free_clients_limit',
        defaultMessage: 'By adding one more client you are going to exceed the limit of {limitNumber} free clients.'
    },
    invitation_sent_question: {
        id: 'invitation_sent_question',
        defaultMessage: 'Connection Requested?'
    },
    connection_link: {
        id: 'Link',
        defaultMessage: 'Connection Link'
    },
    pending: {
        id: 'Pending',
        defaultMessage: 'Pending'
    },
    invitation_sent: {
        id: 'messages.invitation_sent',
        defaultMessage: 'Connection request sent.'
    },
    copy_link: {
        id: 'Copy link',
        defaultMessage: 'Copy link'
    },
    dont_have_invitations: {
        id: 'dont_have_invitations',
        defaultMessage: "You don't have any invited clients now."
    },
    dont_have_members: {
        id: 'dont_have_invitations',
        defaultMessage: "You don't have any invited members now."
    },
    rejected: {
        id: 'rejected',
        defaultMessage: 'REJECTED'
    },
    send_again: {
        id: 'send_again',
        defaultMessage: 'SEND AGAIN'
    },
    status: {
        id: 'status',
        defaultMessage: 'Status'
    },
    client_account: {
        id: 'messages.client_account',
        defaultMessage: "This email is registered like client's account."
    },
    have_account: {
        id: 'have_account',
        defaultMessage: "If the new member already has an account on the MyFitWorld platform, please enter their email."
    },
    doesnt_have_account: {
        id: 'doesnt_have_account',
        defaultMessage: "If the member doesn't have an account, copy the registration link."
    },
    copy_link_for_new_member: {
         id: 'copy_link_for_new_member',
        defaultMessage: "Copy the registration link for your new member."
    },
    copied_link: {
        id: 'copied_link',
        defaultMessage: 'Copied link'
    },
    doesnt_have_account_title: {
        id: 'doesnt_have_account_title',
        defaultMessage: "If the new member doesn't have an account, do the following:"
    },
    doesnt_have_account_step_one: {
        id: 'doesnt_have_account_step_one',
        defaultMessage: '1. Select the role you want them to have in your organization.'
    },
    doesnt_have_account_step_two: {
        id: 'doesnt_have_account_step_two',
        defaultMessage: '2. Copy the link and send it to the new member.'
    },
    doesnt_have_account_text: {
        id: 'doesnt_have_account_text',
        defaultMessage: 'Once they register through the link, the new member will become part of your organization with the assigned role.'
    },
    doesnt_have_account_note: {
        id: 'doesnt_have_account_note',
        defaultMessage: "*NOTE: You don't need to enter an email in the field, it can be left blank."
    },
    maximum_free_clients: {
        id: 'invitation.maximum_free_clients',
        defaultMessage: "You have reached the maximum number of clients allowed on your current plan.\nTo add more clients, please contact us at office@myfitworld.net."
    },
    upgrade_subscription: {
        id: 'invitation.upgrade_subscription',
        defaultMessage: "You can {manageSubscription} or {schedule} a quick 10-minute online call with us for help."
    },
    manage_your_subscription: {
        id: 'invitation.manage_your_subscription',
        defaultMessage: 'manage your subscription'
    },
    schedule: {
        id: 'invitation.schedule',
        defaultMessage: 'schedule'
    }
})
export default messages;
